package one.healthium.tutorial.domain

import one.healthium.base.preferences.AppPreferences
import one.primehealth.app.BaseAppConfig

class TutorialInteractor(
    private val tutorialRepository: TutorialRepository,
    private val appPreferences: AppPreferences,
    private val appConfig: BaseAppConfig,
) {

    suspend fun getTutorial(): TutorialModel? {
        when {
            appPreferences.introTutorialShown.not() -> {
                return tutorialRepository.getIntro()
            }

            appPreferences.isMealPlanTutorialShown.not() && appConfig.features.personalMealPlanEnabled -> {
                return TutorialModel.MealPlanTutorial
            }
        }

        return null
    }

    fun setIntroTutorialShown() {
        appPreferences.introTutorialShown = true
        if (appConfig.features.personalMealPlanEnabled) {
            // no need to show meal plan tutorial in this case since now by default assigned personal meal plan
            appPreferences.isMealPlanTutorialShown = true
        }
    }
}